import React, { ChangeEventHandler } from 'react'
import { Theme } from '@opallabs/gem'

type RadioGroupContextValue = {
  name: string
  value: string | undefined
  onChange: ChangeEventHandler<HTMLInputElement>
  theme: Theme
}
const RadioGroupContext = React.createContext<
  RadioGroupContextValue | undefined
>(undefined)

type RadioGroupProviderOptions = {
  defaultValue?: string
  onChange?: React.ChangeEventHandler<HTMLInputElement>
  name: string
  theme: Theme
}

export const RadioGroupProvider: React.FC<
  React.PropsWithChildren<RadioGroupProviderOptions>
> = ({ children, defaultValue, name, onChange, theme }): JSX.Element => {
  const [value, setValue] = React.useState<string | undefined>(defaultValue)
  const handleOnChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    setValue(e.target.value)
    onChange?.(e)
  }

  return (
    <RadioGroupContext.Provider
      value={{
        name,
        onChange: handleOnChange,
        value,
        theme,
      }}
    >
      {children}
    </RadioGroupContext.Provider>
  )
}

export const useRadioGroup = (): RadioGroupContextValue => {
  const radioGroupContext = React.useContext(RadioGroupContext)
  if (radioGroupContext === undefined) {
    throw new Error('RadioInput must be used within a RadioGroup.')
  }

  return radioGroupContext
}
